import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";
import AddFile from "./add_file.js";

const MySwal = withReactContent(Swal2);

const EditPelnSub = (props) => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [lawyerOptions, setLawyerOptions] = useState([]);
  const [bankLawyers, setBankLawyers] = useState([]);
  const [lawyerTable, setLawyerTable] = useState(
    props.client.pel_sub === undefined ||
      props.client.pel_sub === null ||
      props.client.pel_sub === ""
      ? []
      : props.client.pel_sub.split(",")
  );
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [inputs, setInputs] = useState({});
  const [showAddFile, setShowAddFile] = useState(false);

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const fetchBanks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getPelSubLawyers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBankLawyers(data);
        setLawyerOptions(createLawyerOptions(data));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchBanks();
  };

  useEffect(() => {
    getData();
  }, []);

  const addClient = async (e) => {
    if (value === "") {
      return;
    }
    if (lawyerTable.filter((el) => el === value).length > 0) {
      MySwal.fire({
        icon: "error",
        title: "Podano",
        text: "tego samego pełnomocnika",
      }).then(async (result) => {});
    } else {
      lawyerTable.push(value);
      setValue("");
    }
  };

  const deleteClient = async (e) => {
    setLawyerTable(lawyerTable.filter((el) => el !== e.target.value));
  };

  const generateLawyers = () => {
    var ret = "";
    lawyerTable.map((el, index) => {
      if (index === 0) {
        ret = ret + el;
      } else {
        ret = ret + ", " + el;
      }
    });

    return ret;
  };

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        clientId: props.client.id,
        field: "pel_sub",
        value: generateLawyers(),
      };

      await fetch("https://apidevkppp.ftpeople.pl/updateFieldClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {
          if (props.mode === "letter" || props.mode === undefined) {
            props.close();
          } else if (props.mode === "task" || props.mode === undefined) {
            MySwal.fire({
              icon: "success",
              title: "Edytowano",
              text: "sprawę",
            }).then(async (result) => {
              props.close();
            });
          } else {
            MySwal.fire({
              title: "Czy chcesz dodać plik?",
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: "Tak",
              denyButtonText: `Nie`,
            }).then((result) => {
              if (result.isConfirmed) {
                setLoading(false);
                setShowAddFile(true);
              } else if (result.isDenied) {
                props.logClientAction(
                  "Dodanie substytuta: " +
                    (new Date().getFullYear() +
                      "-" +
                      (new Date().getMonth() + 1 < 10
                        ? "0" + (new Date().getMonth() + 1)
                        : new Date().getMonth() + 1) +
                      "-" +
                      (new Date().getDate() < 10
                        ? "0" + new Date().getDate()
                        : new Date().getDate()) +
                      " " +
                      (new Date().getHours() < 10
                        ? "0" + new Date().getHours()
                        : new Date().getHours()) +
                      ":" +
                      (new Date().getHours() < 10
                        ? "0" + new Date().getMinutes()
                        : new Date().getMinutes())),
                  props.client.id
                );

                if (props.mode === "task" || props.mode === "letter") {
                  props.close();
                } else {
                  MySwal.fire({
                    icon: "success",
                    title: "Edytowano",
                    text: "sprawę",
                  }).then(async (result) => {
                    props.close();
                  });
                }
              }
            });
          }
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    return true;
    if (lawyerTable.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const closeAddFile = () => {
    setShowAddFile(false);
    props.close();
  };

  const closeAddFileNoFile = () => {
    setShowAddFile(false);
    props.logClientAction(
      "Edytowano informację o pełnomocniku substytucyjnym",
      props.client.id
    );

    MySwal.fire({
      icon: "success",
      title: "Edytowano",
      text: "sprawę",
    }).then(async (result) => {
      props.close();
    });
  };

  const createLawyerOptions = (data) => {
    var bankOptions = [];
    bankOptions.push({ label: "brak danych", value: "brak danych" });
    data.map((el) => {
      bankOptions.push({ label: el.name, value: el.name });
    });

    return bankOptions;
  };

  return (
    <div
      style={{ width: "50vw", minHeight: "32vh", zIndex: "9999" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          {showAddFile ? (
            <>
              <AddFile
                close={closeAddFile}
                closeNoFile={closeAddFileNoFile}
                id={props.client.id}
                place={"sub"}
                logClientAction={props.logClientAction}
                peln="1"
              />
            </>
          ) : (
            ""
          )}

          <div className="inputBox">
            <div className="inputCol_2">
              <label>
                Pełnomocnik substytucyjny{" "}
                <span className="requiredStar">*</span>
              </label>
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                value={
                  value === ""
                    ? { label: "Wybierz...", value: "Wybierz..." }
                    : { label: value, value: value }
                }
                options={lawyerOptions}
                onChange={(e) => setValue(e.value)}
              />
            </div>
            <div
              style={{ display: "flex", alignItems: "end" }}
              className="inputCol_2"
            >
              <button className="paymentMenuButton" onClick={addClient}>
                DODAJ
              </button>
            </div>
          </div>
          <div style={{ marginTop: "3vh" }}>
            {lawyerTable.length > 0 ? (
              <>
                {lawyerTable.map((el) => (
                  <>
                    <div
                      style={{ display: "flex", gap: "10px", marginTop: "1vh" }}
                    >
                      <div style={{ width: "80%" }}>{el}</div>
                      <div style={{ width: "20%" }}>
                        <button
                          className="paymentMenuButton"
                          value={el}
                          onClick={deleteClient}
                        >
                          USUŃ
                        </button>
                      </div>
                    </div>
                  </>
                ))}
              </>
            ) : (
              ""
            )}
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditPelnSub;
